// OneDrive:IgnoreCodeCoverage

/**
 * check if the user is current login user
 * Explanation: sometimes a user has two email address: upn@company.com and firstname.lastname@company.com,
 * to check if the user is login user, we need check both these emails.
 */
export function isCurrentLoginUser(userEmail?: string, currentUserLoginName?: string, currentUserEmail?: string): boolean {
  const lowerCaseUserEmail = userEmail && userEmail.toLowerCase();
  const lowerCaseCurrentUserLoginName = currentUserLoginName && currentUserLoginName.toLowerCase();
  const lowerCaseCurrentUserEmail = currentUserEmail && currentUserEmail.toLowerCase();
  return !!(lowerCaseUserEmail === lowerCaseCurrentUserLoginName || lowerCaseUserEmail === lowerCaseCurrentUserEmail);
}